import React, { useCallback, useMemo } from 'react'
import styled from '@emotion/styled'
import { SECONDARY, FONT_BLACK, WHITE } from '../../constant/colors'
import Text from '../../components/common/Text'
import Image from '../../components/common/Image'
import Calendar from '../../assets/images/welfare-calendar.svg'
import { mobile } from '../../utils/responsive-helper'
import { useGetEnrollmentPeriod } from '../../services/enrollment/enrollment-query'
import { useHistory } from 'react-router'
import { enrollment } from '../../constant/path'
import dayjs from 'dayjs'
import { useGetEnrollmentYear } from '../Enrollment'

const WelfareContainer = styled.div`
  background-color: ${SECONDARY};
  border-radius: 10px;
  padding: 12px 16px 10px 16px;
  align-items: center;
  margin-left: -4px;
`

const LeftRightLayout = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
`

const LeftDiv = styled.div`
  display: flex;
  flex-direction: row;
`

const TextDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 20px;
`

const ViewButton = styled(Text)`
  height: 30px;
  border-radius: 15px;
  background-color: ${FONT_BLACK};
  text-align: center;
  align-items: center;
  padding: 2px;
  color: ${WHITE};
  width: 100px;
  cursor: pointer;
  line-height: 25px;
`

const RightDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 200px;
  ${mobile} {
    width: 100%;
  }
`

const Welfare = () => {
  const { data: enrollmentPeriod } = useGetEnrollmentPeriod()
  const { endDate } = enrollmentPeriod || {}
  const history = useHistory()
  const { enrollmentYear } = useGetEnrollmentYear()
  const onClick = useCallback(() => {
    history.push(enrollment())
  }, [history])
  return (
    <WelfareContainer>
      <LeftRightLayout>
        <LeftDiv>
          <Image src={Calendar} style={{ objectFit: 'contain' }} />
          <TextDiv>
            <Text type="SemiBold">{`ปรับเปลี่ยนสวัสดิการบริษัทของปีหน้า (${enrollmentYear}) ได้แล้ววันนี้`}</Text>
            <Text>{`ถึงวันที่ ${dayjs(Number(endDate))
              .add(543, 'year')
              .format('DD MMM YYYY')}`}</Text>
          </TextDiv>
        </LeftDiv>

        <RightDiv>
          <ViewButton size={14} onClick={onClick}>
            ดูสวัสดิการ
          </ViewButton>
        </RightDiv>
      </LeftRightLayout>
    </WelfareContainer>
  )
}

export default Welfare
